import { Box, Button, Modal } from "@mui/material"
import SettingsActivatedButton from "../settingsButtons/SettingsActivatedButton"
import { useSelector } from "react-redux";
import { AppState } from "../../../core/app/AppReducer";
import { useDispatch } from "react-redux";
import { setAllSoulSanity, setBeatableOnly, setBkSanity, setBombchuBag, setBossesShuffle, setBossSoulSanity, setClosedDot, setCowsanity, setErDungeon, setItemPoolMinimal, setItemPoolScarce, setKeyring, setKeysanityAll, setKeysy, setMixPool, setMixPoolDungeon, setNoCamc, setNoZl, setOcarinaShuffle, setOneMajorItem, setOpenDeku, 
    setOpenFountain, setRandomOwlWarp, setRegionalSoulSanity, setScrubsanity, setShopsanity, setShortcut, setShuffleGerudoCard, setSongDungeonReward, setSongsanity,  setTokenDungeon,  setTrials } from "./TournoiFrancoReducer";


export interface ModalSettingsProps {
    isOpen: boolean
    setOpen: (v: boolean) => void
}

const ModalSettings = (props: ModalSettingsProps) => {

    let state = useSelector((state: AppState) => state.ui.ootr.tournoiFranco);

    let dispatch = useDispatch();


    return <Modal open={props.isOpen ?? false} hideBackdrop  sx={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        maxHeight: "800px",
        width: "800px",
        backgroundColor: "rgba(50,50,50,1)",
        overflow: "overflow",
        borderRadius: "5%",
        padding: "5px",
        border: "none"
    }}>
        <Box display={"flex"} flexDirection={"column"}>
          <Box textAlign={"center"} component={"h2"}>Classique Settings</Box>
        <Box display={"flex"} flexDirection={"row"} flexWrap={"wrap"}>
            <SettingsActivatedButton name="No CAMC" setter={setNoCamc} value={state.noCamc}/>
            <SettingsActivatedButton name="No Free ZL" setter={setNoZl} value={state.noZl} />
            <SettingsActivatedButton name="Keysy" setter={setKeysy} value={state.keysy} additionalOnClick={() => {
                dispatch(setKeysanityAll(false));
                dispatch(setKeyring(false));
            }}/>
            <SettingsActivatedButton name="Open Deku" setter={setOpenDeku} value={state.openDeku} />
            <SettingsActivatedButton name="Open Fountain" setter={setOpenFountain} value={state.openFountain} />
            <SettingsActivatedButton name="Gerudo Card" setter={setShuffleGerudoCard} value={state.shuffleGerudoCard} />
            <SettingsActivatedButton name="One Major Item" setter={setOneMajorItem} value={state.oneMajorItem} />
            <SettingsActivatedButton name="Boss shuffle" setter={setBossesShuffle} value={state.bossShuffle} />
            <SettingsActivatedButton name="ER Dungeon" setter={setErDungeon} value={state.erDungeon} />
            <SettingsActivatedButton name="Bombchu Bag" setter={setBombchuBag} value={state.bombchuBag} />
            <SettingsActivatedButton name="Ocarina Shuffle" setter={setOcarinaShuffle} value={state.ocarinaShuffle}/>
            <SettingsActivatedButton name="Songsanity Anywhere" setter={setSongsanity} value={state.songsanity} additionalOnClick={() => {
                dispatch(setSongDungeonReward(false));
            }}/>
            <SettingsActivatedButton name="Shopsanity" setter={setShopsanity} value={state.shopSanity}/>
            <SettingsActivatedButton name="Tokens (Dungeons)" setter={setTokenDungeon} value={state.tokenDungeons}/>
            <SettingsActivatedButton name="BK sanity" setter={setBkSanity} value={state.bkSanity}/>
            <SettingsActivatedButton name="Random Owl / Warp" setter={setRandomOwlWarp} value={state.randomOwlWarp}/>
            <SettingsActivatedButton name="Closed DoT" setter={setClosedDot} value={state.closedDot}/>
            <SettingsActivatedButton name="Cow Sanity" setter={setCowsanity} value={state.cowSanity}/>
            <SettingsActivatedButton name="Scrub Sanity" setter={setScrubsanity} value={state.scrubSanity}/>
            <SettingsActivatedButton name="Boss Soul sanity" setter={setBossSoulSanity} value={state.bossSoulSanity} additionalOnClick={() => {
                dispatch(setAllSoulSanity(false));
                dispatch(setRegionalSoulSanity(false));
            }} />

      </Box>
      <Box textAlign={"center"} component={"h2"}>Hardcore Settings</Box>
      <Box  display={"flex"} flexDirection={"row"} flexWrap={"wrap"}>
        <SettingsActivatedButton name="Trials" setter={setTrials} value={state.trials}/>
        <SettingsActivatedButton name="Regional Soul Sanity" setter={setRegionalSoulSanity} value={state.regionalSoulSanity} additionalOnClick={() => {
            dispatch(setBossSoulSanity(false));
            dispatch(setAllSoulSanity(false));
        }}/> 
        <SettingsActivatedButton name="All Soul Sanity" setter={setAllSoulSanity} value={state.allSoulSanity} additionalOnClick={() => {
            dispatch(setBossSoulSanity(false));
            dispatch(setRegionalSoulSanity(false));
        }}/>
        <SettingsActivatedButton name="Keysanity Anywhere" setter={setKeysanityAll} value={state.keysanityAll} additionalOnClick={() => {
            dispatch(setKeysy(false));
        }}/>
        <SettingsActivatedButton name="Keyring" setter={setKeyring} value={state.keyring} additionalOnClick={() => {
            dispatch(setKeysy(false));
        }}/>
         <SettingsActivatedButton name="Shortcut" setter={setShortcut} value={state.shortcut} />
         <SettingsActivatedButton name="Song dungeon Reward" setter={setSongDungeonReward} value={state.songDungeonReward}  additionalOnClick={() => {
            dispatch(setSongsanity(false));
        }}/>
        <SettingsActivatedButton name="Mixpool" setter={setMixPool} value={state.mixPool} />
        <SettingsActivatedButton name="Add Dungeon MixPool" setter={setMixPoolDungeon} value={state.mixPoolDungeon} disabled={!state.mixPool} />
        <SettingsActivatedButton name="Item Pool Minimal" setter={setItemPoolMinimal} value={state.itemPoolMinimal}  additionalOnClick={() => {
            dispatch(setItemPoolMinimal(false));
        }}/>
        <SettingsActivatedButton name="Item Pool Scarce" setter={setItemPoolScarce} value={state.itemPoolScarce}  additionalOnClick={() => {
            dispatch(setItemPoolScarce(false));
        }}/>
        <SettingsActivatedButton name="Beatable Only" setter={setBeatableOnly} value={state.beatableOnly}  />
        
      </Box>
        <Box display={"flex"} width={"100%"} justifyContent={"center"}>
          <Button color={"error"} variant="outlined" onClick={() => props.setOpen(false)}>Close</Button>
          </Box>
        </Box>

    </Modal>
}

export default ModalSettings